module.exports = __webpack_public_path__ + "media/images/icon_nav_ranking_white-11e02d2acebafd56c9639de8cb4b0ec3.svg";